import * as React from "react";
import { Badge } from "../../components";
import IHomework from "../../typings/IHomework";
import { tl } from "../../utils";

const statusStyles = new Map([
  ["accepted", "success"],
  ["rejected", "danger"],
  ["", "info"],
  ["inqueue", "info"]
]);

const statusText = new Map([
  ["accepted", "Зачет"],
  ["deleted", "Удалено"],
  ["rejected", "Незачет"],
  ["defer", "Отложен"],
  ["", "Новый"],
  ["inqueue", "Новый"],
  ["checking", "Проверяется"]
]);

export default class Homework extends React.Component<{
  homework: IHomework;
}> {
  render() {
    //@ts-ignore
    const checkType = this.props.homework.lesson.settings[
      this.props.homework.lesson.type
    ].check_type;

    if (this.props.homework.status === "inqueue" && this.props.homework.checking)
      return (
        <a href={this.props.homework.checkUrl} style={{ textDecoration: "none" }}>
          <span title={this.props.homework.checking.fullname}>
            <Badge type="rect" >
              {statusText.get("checking")}
            </Badge>
          </span>
        </a>
      )

    return (
      <a href={this.props.homework.checkUrl} style={{ textDecoration: "none" }}>
        <Badge style={statusStyles.get(this.props.homework.status)} type="rect">
          {checkType === "rating" &&
          this.props.homework.rating
            ? this.props.homework.rating
            : tl(this.props.homework.statusHumanized || statusText.get(this.props.homework.status))}
        </Badge>
      </a>
    );
  }
}
